import React, { Fragment, useEffect, useState } from 'react';
import { Convert, FnAxios, FnDialog, I18n, undefinedOrNull, } from "utilities/utilities";
import { ApiLeave } from "enum/api";
import { APIStatusCode, EnumModeProfiles, EnumSaveModeLeave, I18NextNs } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import Profiles from './components/Profiles';
import { FormLabel, Grid } from '@mui/material';
import { BtnApproveOnTable, BtnEditOnTable, BtnViewDataOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import { RadioListItem } from 'components/Input/Radio';
import { FormProvider, useForm } from 'react-hook-form';
import { DateRangePickerItem } from 'components/Input/DatePicker/DateRangePickerItem';
import { BtnAddRequestLeave, BtnApprove, BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import ModalApprover from './components/ModalApprover';

const LeaveList = () => {
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const DialogFn = FnDialog();
    const location = useLocation();
    
    const [isModalApprover, setisModalApprover] = useState(false);
    const [ObjApprover, setObjApprover] = useState(null);
    const [isLoadingTable, setisLoadingTable] = useState(false);    

    const [isPermission, setPermission] = useState<boolean>(false); // Permission true = Edit | false = View, Disabled
    const [loadingTable, setLoadingTable] = useState(false);
    const [isDeputize, setisDeputize] = useState(false); //(Part > ผอ.ส่วน > true ||Pile > ผอ.กอง > true ) || null > ไม่ใช่ ผอ. ทั้ง 2 false
    const [isBtnAdd, setisBtnAdd] = useState(false);
    const [nUserID, setnUserID] = useState(null);    
    const [nYear, setnYear] = useState((+new Date().getFullYear) + 543);
    const [nStartDate, setnStartDate] = useState(null);
    const [arrUserID, setarrUserID] = useState<any>([]);
    const [arrLeaveTypeID, setarrLeaveTypeID] = useState<any>([]);
    const [arrStatusID, setarrStatusID] = useState<any>([]);
    const [arrTypeID, setarrTypeID] = useState<any>([]);

    const [arrSelect, setarrSelect] = useState<any>([]);
    
    const currentDate = new Date(); // Get the current date
    const _dStart = new Date(currentDate.getFullYear(), 0, 1); //01/01/New
    const _dEnd = new Date(currentDate.getFullYear(), 12, 0); //31/12/New

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sNameRequestLeave: null,
            sLeaveType: null,
            sStatus: null,
            sType: 1,
            // dDateRange: [_dStart, _dEnd],
            dStartDate: _dStart,
            dEndDate: _dEnd,
        } as any,
    });

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
        GetFormInitial();      
        // handleGetTableLeave(dataRow);  
    }, []);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiLeave.GetFormInitial, {}, (result) => {
            setisDeputize(result.isDeputize); //Part > ผอ.ส่วน > true ||Pile > ผอ.กอง > false || null > ไม่ใช่ ผอ. ทั้ง 2
            setnUserID(result.nUserID);
            setnYear(result.nYear);
            setnStartDate(result.nStartDate);
            setarrUserID(result.lstUserID);
            if (!result.isDeputize) form.setValue("sNameRequestLeave", result.lstUserID.filter(f => f.value === result.nUserID).map(m => m.value)); 
            setisBtnAdd(result.isBtnAdd);
            if (!result.isBtnAdd && !result.isDeputize) {
                DialogFn.Warning("สิทธิ์วันลาคงเหลือของคุณไม่มี ไม่สามารถทำการเพิ่มข้อมูลวันลาได้.");
            }
            setarrLeaveTypeID(result.lstLeaveTypeID);
            form.setValue("sLeaveType", result.lstLeaveTypeID.map(m => m.value));
            setarrStatusID(result.lstStatusID);
            form.setValue("sStatus", result.lstStatusID.filter(f => f.value !== 8).map(m => m.value));
            setarrTypeID(result.lstTypeID);
            handleGetTableLeave(dataRow);
        });
    }

    useEffect(() => {
        if (isLoadingTable === true)
        {
            handleGetTableLeave(dataRow);
            setisLoadingTable(false);
        }
    }, [isLoadingTable]);    

    const handleGetTableLeave = (p: PaginationInterface) => {
        setLoadingTable(true);
        let ObjForm = form.getValues();

        // // let dStart = ObjForm.dDateRange && ObjForm.dDateRange[0] ? Convert.DateTimeToString(ObjForm.dDateRange[0], "YYYY-MM-DD") : null;
        // // let dEnd = ObjForm.dDateRange && ObjForm.dDateRange[1] ? Convert.DateTimeToString(ObjForm.dDateRange[1], "YYYY-MM-DD") : null;
        // let nDate_Start = ObjForm.dDateRange && ObjForm.dDateRange[0] ? ObjForm.dDateRange[0].valueOf() : null;
        // let nDate_End = ObjForm.dDateRange && ObjForm.dDateRange[1] ? ObjForm.dDateRange[1].valueOf()  : null;

        let nDate_Start = ObjForm.dStartDate ? ObjForm.dStartDate.valueOf() : null;
        let nDate_End = ObjForm.dEndDate ? ObjForm.dEndDate.valueOf() : null;

        let objParam = {
            ...p,
            lstUserID: ObjForm.sNameRequestLeave ?? [],
            lstLeaveTypeID: ObjForm.sLeaveType ?? [],
            lstStatusID: ObjForm.sStatus ?? [],
            isType: ObjForm.sType === 1,
            nStartDate: nDate_Start,
            nEndDate: nDate_End,
        };
        AxiosFn.Post(ApiLeave.GetTableLeave, objParam, (result) => {
            setLoadingTable(false);
            if (result.nStatusCode === APIStatusCode.Success) 
            {
                setDataRow({
                    ...p,
                    arrRows: result.lstDataLeave ?? [],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    };

    const goToEdit = (sID: string, sMode: string) => {
        let sUrl = "/LeaveFrom";
        navigate(sUrl, { state: { sID: sID, sMode: sMode} });
        // <a style={{ paddingTop: '10px' }} href={"/LeaveFrom"} target="_blank" rel="noreferrer"></a>
    };

    const dataColumn: any = [
        {
            field: "isBtnApproval",
            headerName: `${I18n.SetText("Leave.sCarryOut")}`,
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 100,
            flex: 1,
            getActions: (item) => {
                return [
                    item.row.isBtnApproval ? 
                            <BtnApproveOnTable
                                key={item.row.sID}
                                id="btnApprove"
                                onClick={() => onOpenModal(item.row.nLeaveID, item.row.nApproveID, item.row.nApprovePositionID, item.row.nStatusID, item.row.nUserID)}
                                IsDisabled={!isPermission}
                            />
                        :
                            item.row.isEdit ?
                                <BtnEditOnTable
                                    key={item.row.sID}
                                    id="btnEdit"
                                    onClick={() => goToEdit(item.row.nLeaveID, "Edit" )}
                                    IsDisabled={!isPermission}
                                />
                            :
                                <BtnViewDataOnTable
                                    key={item.row.sID}
                                    id="btnView"
                                    onClick={() => goToEdit(item.row.nLeaveID, "View")}
                                    // IsDisabled={isPermission}
                                />
                ];
            },
        },
        {
            field: "sStatusName",
            headerName: `${I18n.SetText("Leave.sStatus")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 2,
            // width: 280,
        },
        {
            field: "sSubmissionDate",
            headerName: `${I18n.SetText("Leave.sSubmissionDate")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 1,
            // width: 120,
        },
        {
            field: "sFName",
            headerName: `${I18n.SetText("Leave.sFirstName")}`,
            headerAlign: "center",
            align: "left",
            sortable: true,
            flex: 2,
            // width: 200,
        },
        {
            field: "sLName",
            headerName: `${I18n.SetText("Leave.sLastName")}`,
            headerAlign: "center",
            align: "left",
            sortable: true,
            flex: 2,
            // width: 200,
        },
        {
            field: "sLeaveType",
            headerName: `${I18n.SetText("Leave.sLeaveType")}`,
            headerAlign: "center",
            align: "left",
            sortable: true,
            flex: 1,
            // width: 100,
        },
        {
            field: "sStartDate",
            headerName: `${I18n.SetText("Leave.sLeaveStartDate")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 1,
            // width: 120,
        },
        {
            field: "sEndDate",
            headerName: `${I18n.SetText("Leave.sLeaveEndDate")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 1,
            // width: 120,
        },
    ];
    
    const onOpenModal = (nLeaveID: number, nApproveID: number, nApprovePositionID: number, nStatusID: number, nUserID: number) => {
        setisModalApprover(true);
        setObjApprover({nLeaveID: nLeaveID, nApproveID: nApproveID, nApprovePositionID: nApprovePositionID, nFromStatusID: nStatusID, nUserID: nUserID, nYear: nYear});
    };

    const handleSaveApproveLeaveAll = () => {
        DialogFn.BlockUI();
        let lstnLeaveID = (arrSelect ?? []).map(m => undefinedOrNull(m, "number"));
        AxiosFn.Post(ApiLeave.SaveApproveLeaveAll, {lstnLeaveID: lstnLeaveID, sLocation: location.pathname,}, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === APIStatusCode.Success)
            {
                DialogFn.Success(I18n.SetText("Message.SaveApproveComplete", I18NextNs.labelComponent), () => { setisLoadingTable(true);});
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    };
    
    return (
        <Grid item xs={12} md={12} container spacing={1} justifyItems={'flex-start'} justifyContent={'flex-start'}>
            <Grid item xs={12} md={12}>
                {!isDeputize && <Profiles nUserID={nUserID} nYear={nYear} nMode={EnumModeProfiles.Leave} />}
            </Grid>
            <Grid item xs={12} md={12} container spacing={1} justifyItems={'flex-start'} justifyContent={'flex-start'}>
                {/* <Grid item xs={12} md={2}>
                    {!isDeputize && isBtnAdd && isPermission && <BtnAddRequestLeave id={'btnAddLeave'} txt={`${I18n.SetText("Leave.sRequestLeave")}`} sSize={"large"} onClick={() => { navigate("/LeaveFrom"); }} />}
                    {arrSelect.length > 0 && isPermission && <BtnApprove id={'btnApprove'} sSize={"large"} onClick={() => { handleSaveApproveLeaveAll(); }} />}
                </Grid>*/}
                <Grid item xs={12} md={2}></Grid>
                <Grid item xs={12} md={10} container spacing={2} justifyItems={'flex-start'} justifyContent={'end'}>
                    <FormProvider {...form}>
                        <Grid item xs={12} md={5}>
                            <MultipleSelectItem
                                id={"sNameRequestLeave"}
                                name={"sNameRequestLeave"}
                                label={`${I18n.SetText("Leave.sNameRequestLeave")}`}
                                required={false}
                                options={arrUserID}  
                                // disabled={!isDeputize}       
                                limitTag={1}                   
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <MultipleSelectItem
                                id={"sLeaveType"}
                                name={"sLeaveType"}
                                label={`${I18n.SetText("Leave.sLeaveType")}`}
                                required={false}
                                options={arrLeaveTypeID}    
                                disabled={false}   
                                limitTag={1}                       
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <MultipleSelectItem
                                id={"sStatus"}
                                name={"sStatus"}
                                label={`${I18n.SetText("Leave.sStatus")}`}
                                required={false}
                                options={arrStatusID}       
                                disabled={false}      
                                limitTag={1}                 
                            />
                        </Grid>
                        <Grid item xs={12} md={4} container spacing={1}>
                            <Grid item xs={12} md={3}>
                                <FormLabel component="legend" style={{ padding: 'inherit',}}>{`${I18n.SetText("Leave.sType")}`}</FormLabel>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <RadioListItem
                                    id={"sType"}
                                    name={"sType"}
                                    // label={`${I18n.SetText("Leave.sType")}`}
                                    required={false}
                                    options={arrTypeID}    
                                    disabled={false}  
                                />
                            </Grid>
                        </Grid>      
                        {/* <Grid item xs={12} md={5.5}>
                            <DateRangePickerItem
                                id={"dDateRange"}
                                name={"dDateRange"}
                                labelStart={`${I18n.SetText("Leave.sStartDate")}`}
                                labelEnd={`${I18n.SetText("Leave.sEndDate")}`}                                
                                required={false}
                                disabled={false}
                            />
                        </Grid> */}
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                name={"dStartDate"}
                                id={"dStartDate"}
                                label={`${I18n.SetText("Leave.sStartDate")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}  
                                maxDate={form.watch("dEndDate")}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                name={"dEndDate"}
                                id={"dEndDate"}
                                label={`${I18n.SetText("Leave.sEndDate")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}  
                                minDate={form.watch("dStartDate")}
                            />
                        </Grid>
                        <Grid item xs={12} md={1.5} container spacing={1} justifyItems={'flex-start'} justifyContent={'end'}> 
                            <Grid item>
                                <BtnClear 
                                    id={'btnClearSearchAll'} 
                                    IsCircleWithOutText={true} 
                                    onClick={()=> { 
                                        form.reset(); 

                                        if (!isDeputize) form.setValue("sNameRequestLeave", arrUserID.filter(f => f.value === nUserID).map(m => m.value));
                                        form.setValue("sLeaveType", arrLeaveTypeID.map(m => m.value));
                                        form.setValue("sStatus", arrStatusID.filter(f => f.value !== 8).map(m => m.value));
                                    }} 
                                />
                            </Grid>
                            <Grid item>
                                <BtnSearch id={'btnSearchAll'} IsCircleWithOutText={true} onClick={()=> { handleGetTableLeave(dataRow); }} />
                            </Grid>
                        </Grid>
                    </FormProvider>              
                </Grid>  
                <Grid item xs={12} md={6}>
                    {!isDeputize && isBtnAdd && isPermission && <BtnAddRequestLeave id={'btnAddLeave'} txt={`${I18n.SetText("Leave.sRequestLeave")}`} sSize={"large"} onClick={() => { navigate("/LeaveFrom"); }} />}
                    {arrSelect.length > 0 && isPermission && <BtnApprove id={'btnApprove'} sSize={"large"} onClick={() => { handleSaveApproveLeaveAll(); }} />}
                </Grid>              
            </Grid>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='TB_Leave'
                    isLoading={loadingTable}
                    columns={dataColumn}
                    rows={dataRow}
                    onLoadData={handleGetTableLeave}
                    isHiddenToolHead={true}
                    isShowCheckBox={!isDeputize ? false : isPermission}
                    // arrSelect={dataRow.arrRows.filter(f=> f.isBtnApproval === true).map(m => m.sID)}
                    // isDisableColumnReorder={isView}
                    onRowSelectable={(p) => p.row.isBtnApproval}
                    setArrSelect={setarrSelect}
                />
            </Grid>
            {isModalApprover && <ModalApprover isModalApprover={isModalApprover} ObjApprover={ObjApprover} setisModalApprover={setisModalApprover} setisLoadingTable={setisLoadingTable} />}
        </Grid>
    )
}
export default LeaveList;